import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App as AntdApp, message } from 'antd'
import App from './App'
import AppUpdateNavigationBridge from './components/common/AppUpdateNavigationBridge'
import { AuthProvider } from './contexts/AuthContext'
import { I18nProvider } from './i18n'
import { startAppUpdateMonitor } from './utils/appUpdateMonitor'
import './index.css'
import './styles/global.css'

startAppUpdateMonitor()
message.config({ maxCount: 3 })

ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
        <BrowserRouter>
            <AppUpdateNavigationBridge />
            <I18nProvider>
                <AntdApp message={{ maxCount: 3 }}>
                    <AuthProvider>
                        <App />
                    </AuthProvider>
                </AntdApp>
            </I18nProvider>
        </BrowserRouter>
    </React.StrictMode>
)
